import { chartStyles } from "../../styles"
import { Checkbox } from "@material-ui/core"
import { useI18n } from "providers/I18n"
import { LegendItemRootLayout } from "./DetailsLayout/FiltersChartLayout/LegendItemRootLayout"

export function LegendItemAllCheckbox({
  keyIndex,
  onChange,
  checked,
  legendItems,
}: {
  keyIndex: number
  onChange: (idx: number, items: string[]) => void
  checked: boolean
  legendItems: string[]
}) {
  const { t } = useI18n()

  return (
    <LegendItemRootLayout title={t("select-all")} selectAll={true}>
      <Checkbox
        id={"checkbox"}
        checked={checked}
        color="primary"
        value="All"
        className={chartStyles.button}
        style={{ padding: 0 }}
        onClick={() => onChange(keyIndex, legendItems)}
      />
    </LegendItemRootLayout>
  )
}
